// metodos de edicion de productos de pedido
import { keyBy } from './index'

//import { TrendingUpRounded } from "@material-ui/icons"


// Helper to remove undefined values from objects recursively for Firestore
const cleanObject = (obj) => {
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(cleanObject);
    
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, v]) => v !== undefined)
            .map(([k, v]) => [k, cleanObject(v)])
    );
}

export const minimizeProduct = (prod) => {
    const {
        id,
        name,
        price,
        qty,
        _cod,
        salePrices,
        composition,
        variants,
        notes,
        smartNotes,
        smartComposition,
        stock,
        active,
        category,
        color,
        combo,
        ...rest
    } = prod

    // Filtramos la composición para quedarnos solo con lo seleccionado o lo que es extra
    const minimizedComposition = (composition || []).filter(item => 
        item && (item.checked || item.extraChecked || item.variant)
    ).map(item => ({
        id: item.id || '',
        name: item.name || '',
        description: item.description || '',
        checked: !!item.checked,
        extraChecked: !!item.extraChecked,
        extraQty: item.extraQty || 0,
        extraPrice: item.extraPrice || 0,
        variant: !!item.variant,
        variantGroup: item.variantGroup || '',
        variantDescription: item.variantDescription || '',
        isExtra: !!item.isExtra
    }))

    const minimized = {
        id: id || '',
        name: name || rest.description || '',
        price: price || 0,
        qty: qty || 0,
        _cod: _cod || 0,
        salePrices: salePrices || null,
        composition: minimizedComposition,
        variants: variants || [],
        notes: notes || '',
        smartNotes: smartNotes || '',
        stock: stock !== undefined ? stock : true,
        active: active !== undefined ? active : true,
        category: category || '',
        color: color || '',
        combo: !!combo
    }

    if (smartComposition) {
        minimized.smartComposition = smartComposition.map(sc => minimizeProduct(sc))
    }

    return cleanObject(minimized)
}


export const generateSmartComposition = prod => {
    console.time(`[perf] generateSmartComposition qty=${prod.qty}`)
    const { qty = 0 } = prod
    let smartComposition = []

    // Minimizamos el producto SIN su smartComposition para crear items base.
    // Esto es CRÍTICO: si pasamos el prod con smartComposition, minimizeProduct
    // llama recursivamente sobre cada item, y cada item tiene los items previos
    // anidados → crecimiento exponencial O(2^n) que congela la UI.
    // Los items individuales representan UNA unidad y no deben tener
    // smartComposition propia.
    const { smartComposition: _stripped, ...prodWithoutSC } = prod
    const baseProductForItems = minimizeProduct(prodWithoutSC)

    if (prod.smartComposition) {
        if (prod.smartComposition.length < qty) {
            // Aumenta cantidad: reutilizamos los items existentes SIN re-minimizarlos
            smartComposition = [...prod.smartComposition]
            let i = prod.smartComposition.length + 1
            for (i; i <= qty; i++) {
                smartComposition.push({ ...baseProductForItems, qty: 1, _cod: i })
            }
        } else if (prod.smartComposition.length > qty) {
            // Disminuye cantidad: recortamos el array sin re-minimizar
            smartComposition = prod.smartComposition.slice(0, qty)
        } else {
            // Misma cantidad: conservamos tal cual
            smartComposition = [...prod.smartComposition]
        }
    } else {
        // Primera vez: creamos todos los items minimizados
        for (let i = 1; i <= qty; i++) {
            smartComposition.push({ ...baseProductForItems, qty: 1, _cod: i })
        }
    }

    console.timeEnd(`[perf] generateSmartComposition qty=${prod.qty}`)
    // Devolvemos el producto ORIGINAL con la smartComposition actualizada
    return {
        ...prod,
        smartComposition
    }
}

export const validateOrder = (order, paymentMethods = []) => {
    let validation = {
        valid: true,
        severity: 'success',
        message: 'Success'
    }

    const { productsList = [], addressId, pickup = false, paymentMethod } = order

    if (paymentMethods?.length > 0 && !paymentMethod) {
        validation.valid = false
        validation.severity = 'warning'
        validation.message = `Seleccione método de pago`
        return validation
    }

    if (!addressId && !pickup) {
        validation.valid = false
        validation.severity = 'warning'
        validation.message = `No se ha seleccionado dirección de entrega`
        return validation
    }

    if (productsList?.length === 0) {
        validation.valid = false
        validation.severity = 'warning'
        validation.message = `No se han añadido productos al carrito`
        return validation
    }

    if (productsList?.filter(p => p.qty < 1).length > 0) {
        validation.valid = false
        validation.severity = 'warning'
        validation.message = `No se ha definido una cantidad para algunos productos`
        return validation
    }

    let stop = false
    productsList?.map(product => {
        if (stop)
            return null

        if (product.smartComposition) {
            const { smartComposition = [], combo } = product

            for (let l = 0; l < smartComposition.length && !stop; l++) {
                const prod = smartComposition[l]
                validation = validateProduct(prod, validation)
                stop = validation.break

                const { variants = [] } = prod

                if (validation.valid) {
                    // eslint-disable-next-line no-loop-func
                    prod?.composition?.some(item => {
                        let _validation = {}

                        if (item.optional && !item.checked)
                            return false

                        validateProduct(item, _validation)
                        if (_validation.valid === false) {
                            const variant = variants.find(v => v.variantGroup === item.variantGroup)
                            // busco si para el mismo variantGroup ya hay otro elemento seleccionado
                            if (variant && variant?.variantId !== item.id)
                                return false
                            validation = _validation
                        }
                        return _validation.valid
                    })
                }
            }

        } else {
            validation = validateProduct(product, validation)
            stop = validation.break
        }

        return null
    })
    return validation
}

// export const createSmartNotesFromOrderProducts = (orderProducts = []) => {
//     let smartNotes = ''
//     //console.log('createSmartNotes', list)
//     orderProducts.forEach((product) => {
//         const { composition = [], variants = [] } = product
//         let firstNote = ''
//         if (orderProducts.length > 1)
//             firstNote = 'Una ' // `${numberToCardinals[_cod]} `

//         let _notes = firstNote
//         composition.forEach(supply => {
//             let text = supply.shortDescription || supply.description || supply.name || ''
//             text = text.toUpperCase()
//             if ((supply.optional || supply.variant) && !supply.checked) {
//                 _notes += `Sin ${text}, `
//             }
//             else if (supply.variantDescription)
//                 _notes += `${supply.variantDescription}, `

//         })
//         if (product.variantDescription)
//             _notes += `${product.variantDescription}, `

//         variants.forEach(variant => {
//             let result = `${variant.variantDescription}, `
//             const subVariants = composition.find(c => c.id === variant.variantId)?.variants?.map(v => v.variantDescription).join()
//             if (subVariants) {
//                 result = `${variant.variantDescription} (${subVariants}), `
//             }
//             _notes += result
//         })

//         if (_notes !== firstNote) {
//             smartNotes += _notes.slice(0, -2) + ' | '
//         }
//     })
//     smartNotes = smartNotes.slice(0, -3).toUpperCase()
//     return smartNotes
// }

export const createSmartNotesFromOrderProducts = (orderProducts = []) => {
    let smartNotes = '';
    let notesList = [];

    orderProducts.forEach((product) => {
        const { composition = [], variants = [], notes = '' } = product;
        let firstNote = '';

        if (orderProducts.length > 1) {
            firstNote = ' ';
        }

        let _notes = firstNote;

        composition.forEach((supply) => {
            let text = supply.shortDescription || supply.description || supply.name || '';
            text = text.toUpperCase();

            if ((supply.optional || supply.variant) && !supply.checked) {
                _notes += `SIN ${text}, `;
            } else if (supply.variantDescription) {
                _notes += `${text}, `;
            } else if (supply.extraChecked) {
                _notes += `EXTRA ${text}, `;
            }
        });

        variants.forEach((variant) => {
            let result = `${variant.variantDescription}, `;
            const subVariants = composition.find((c) => c.id === variant.variantId)?.variants?.map((v) => v.variantDescription).join(', ');

            if (subVariants) {
                result = `${variant.variantDescription} (${subVariants}), `;
            }

            _notes += result;
        });

        if (_notes !== firstNote) {
            _notes = _notes.slice(0, -2) + (notes ? ` (${notes})` : '')
            notesList.push(_notes);
        } else {
            if (notes)
                notesList.push(notes);
        }
    });

    notesList.forEach((note) => {
        smartNotes += `- ${note} |`;
    });

    return smartNotes.trim().toUpperCase();
};

export const formatSmartNotes = (smartNotes = '') => smartNotes.replace(/\|/g, '\n')
export const smartNotesToList = (smartNotes = '') => smartNotes?.split('|').map(comment => comment.trim())

export const hydrateProduct = (minimizedProd, originalProd) => {
    if (!originalProd) return minimizedProd;

    // Clonamos la composición original para no mutarla
    let hydratedComposition = (originalProd.composition || []).map(compItem => {
        // Buscamos si este item estaba en la versión comprimida
        const savedItem = minimizedProd.composition?.find(m => m.id === compItem.id);
        
        if (savedItem) {
            return {
                ...compItem,
                checked: savedItem.checked,
                extraChecked: savedItem.extraChecked,
                extraQty: savedItem.extraQty,
                extraPrice: savedItem.extraPrice,
                variantDescription: savedItem.variantDescription
            };
        }
        
        // Si no estaba, mantenemos el valor por defecto del catálogo (generalmente unchecked)
        return { ...compItem };
    });

    // Hidratamos la smartComposition si existe.
    // Los items individuales representan UNA unidad del producto y no deben
    // hidratar su propio smartComposition (evita crecimiento exponencial en
    // pedidos guardados con estructura anidada del bug anterior).
    let hydratedSmartComposition = minimizedProd.smartComposition?.map(minItem => {
        const { smartComposition: _ignored, ...minItemWithoutSC } = minItem
        return hydrateProduct(minItemWithoutSC, originalProd);
    });

    return {
        ...originalProd,
        ...minimizedProd,
        composition: hydratedComposition,
        smartComposition: hydratedSmartComposition || []
    };
};



const validateProduct = (product, validation) => {
    const { composition = [], variants = [] } = product
    const variantsGrouped = keyBy(composition.filter(v => v.variant), 'variantGroup')
    const variantsGroupedSelected = keyBy(variants, 'variantGroup')


    // console.log('validateProduct', product)
    // console.log('variantsGrouped', variantsGrouped)
    // console.log('variantsGroupedSelected', variantsGroupedSelected)


    Object.keys(variantsGrouped).forEach(variantGroup => {
        const _variantGroup = variantGroup === 'undefined' ? 'Variedad' : variantGroup
        if (!variantsGroupedSelected[_variantGroup]) {
            validation.valid = false
            validation.severity = 'warning'
            validation.message = `No se ha seleccionado ${_variantGroup} para ${product.name || product.description}`
            validation.break = true
        }
    })

    return validation
}
